import { deepCopy } from "../objects";

export function calculateInventory(payload:any) {
    let inventoryPayload:any = { };

    //Taking in cart payload right now. Might have future use.
    const { cartPayload:updatedCartPayload, recipesMap:recipesData } = payload;

    const { cartItems } = updatedCartPayload;
    //calculate for every cart item.
    for (const index in cartItems) {
        const { segments, recipeId, quantity } = cartItems[index];

        const { segments:originalRecipeSegments } = recipesData[recipeId];

        for (const segmentId in segments) {
            const { ingredients } = segments[segmentId];
            const { ingredients:originalSegmentIngredients } = originalRecipeSegments[segmentId];

            for(const ingredientId in ingredients) {
                const { portionSelected, selectedQuantity, portionsCustomised } = ingredients[ingredientId];
                const portions = portionSelected || selectedQuantity || portionsCustomised;
                const { amountPerPortion } = originalSegmentIngredients[ingredientId];
                const requiredIngredientQuantity = portions * amountPerPortion * quantity;

                //Don't calculate anything for 0 or undefined
                //IMP!!!
                //NOTE: Can have negative value which tells the inventory reducer to add back the value in inventory
                if(portions === 0 || typeof portions === "undefined") continue;

                //Add it to payload.
                if(ingredientId in inventoryPayload) {
                    inventoryPayload[ingredientId] += requiredIngredientQuantity;
                } else {
                    inventoryPayload[ingredientId] = requiredIngredientQuantity;
                }
            }
        }
    }

    return { quantityRequired: inventoryPayload };
}

export function validateCartItems({ cartItems, availableItems, recipesMap } : any) {

    let newCartItems = deepCopy(cartItems), currentInventory = deepCopy(availableItems), isCartValid = true , invalidCartItems = [];

    for(const itemIndex in newCartItems) {

        let isCartItemValid = true;
        const { quantity, segments, recipeId } = newCartItems[itemIndex];
        const { segments:originalRecipeSegments } = recipesMap[recipeId];

        for (const segmentId in segments) {
            const { ingredients } = segments[segmentId];
            const { ingredients:originalSegmentIngredients } = originalRecipeSegments[segmentId];

            for (const ingredientId in ingredients) {
                const { portionSelected, selectedQuantity } = ingredients[ingredientId];
                const portions = portionSelected || selectedQuantity;
                const { amountPerPortion } = originalSegmentIngredients[ingredientId];

                if(!portions) continue;

                const requiredIngredientQuantity = portions * amountPerPortion * quantity;
                const availableIngredientQuantity = currentInventory[ingredientId].totalAvailableAmount;

                //Maybe send ingredientId back so that the user might know what is not in sufficient quantity?
                if(requiredIngredientQuantity > availableIngredientQuantity) {
                    // console.log(`Could not satisfy ingredient ${ingredientId}. Needed ${requiredIngredientQuantity}, inventory ${availableIngredientQuantity}`);
                    isCartItemValid = false;
                    break;
                }

                currentInventory[ingredientId].totalAvailableAmount -= requiredIngredientQuantity;
            }
            //Don't parse further as cartitem is already invalid.
            if(!isCartItemValid) break;
        }

        //Add it to invalid cart Items and set the cart as invalid
        if(!isCartItemValid) {
            invalidCartItems.push(itemIndex);
            isCartValid = false;
        }

    }

    return { invalidCartItems , isCartValid }
}